import type { Router } from 'vue-router';
import { useSession } from '@seedkit/vue-administration-module/public';
import { usePermissionsStore } from './permissions.store';

function isAuthenticatedSession(): boolean {
  const session = useSession();
  return !session.isAccessTokenEmpty && !session.isTokenExpired;
}

/**
 * До завершения GetUserPermissions и flushPendingRoutes динамические маршруты модулей
 * ещё не в матчере — без ожидания Vue Router уходит в catch-all 404.
 */
export function installPermissionsRouterGuard(router: Router): void {
  router.beforeEach(async (to, _from, next) => {
    if (!isAuthenticatedSession()) {
      next();
      return;
    }

    const permissionsStore = usePermissionsStore();

    if (!permissionsStore.loaded) {
      await permissionsStore.ensureFetchQueued();
    }

    const resolved = router.resolve({
      path: to.path,
      query: to.query,
      hash: to.hash,
    });

    if (resolved.matched.length > 0) {
      if (to.matched.length === 0) {
        next({
          path: to.path,
          query: to.query,
          hash: to.hash,
          replace: true,
        });
        return;
      }
      next();
      return;
    }

    next();
  });
}
